'use client';

import { c as _c } from "react/compiler-runtime";
import { NexperienceAvailableDatesDocument } from '@data-access/lib/gql/experience/documents';
import { useGraphQL } from '@data-access/lib/graphql-query';
import { keepPreviousData } from '@tanstack/react-query';
import { EXPERIENCE_AVAILABILITY_STALE_TIME, getExperienceAvailableDatesVariables } from '../_lib/experience-availability-query';
import type { SelectedOptions } from '../_lib/experience-state-types';
import { useExperiencePreviewToken } from './use-experience-preview-token';
export function useAppExperienceAvailableDates(publicId, variantId, selectedOptions, t0) {
  const $ = _c(14);
  const enabled = t0 === undefined ? true : t0;
  const previewToken = useExperiencePreviewToken();
  let t1;
  if ($[0] !== previewToken || $[1] !== publicId || $[2] !== selectedOptions || $[3] !== variantId) {
    t1 = getExperienceAvailableDatesVariables({
      publicId,
      previewToken,
      selectedVariant: variantId,
      selectedOptions
    });
    $[0] = previewToken;
    $[1] = publicId;
    $[2] = selectedOptions;
    $[3] = variantId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const variables = t1;
  const t2 = enabled && !!variantId;
  let t3;
  if ($[5] !== t2) {
    t3 = {
      select: _temp2,
      enabled: t2,
      placeholderData: keepPreviousData,
      staleTime: EXPERIENCE_AVAILABILITY_STALE_TIME
    };
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    data,
    isLoading,
    isPlaceholderData,
    isError,
    isFetching,
    refetch,
    errorUpdatedAt,
    dataUpdatedAt
  } = useGraphQL(NexperienceAvailableDatesDocument, variables, t3);
  const t4 = isError || isFetching && errorUpdatedAt > dataUpdatedAt;
  let t5;
  if ($[7] !== data || $[8] !== isFetching || $[9] !== isLoading || $[10] !== isPlaceholderData || $[11] !== refetch || $[12] !== t4) {
    t5 = {
      availableDates: data,
      isLoading,
      isError: t4,
      isFetching,
      refetch,
      isPreliminary: isPlaceholderData
    };
    $[7] = data;
    $[8] = isFetching;
    $[9] = isLoading;
    $[10] = isPlaceholderData;
    $[11] = refetch;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
function _temp2(response) {
  return response.nexperienceAvailableDates.dates.map(_temp);
}
function _temp(date) {
  return date.date;
}